import pathify from "vuex-pathify";
export default pathify;

const debug = process.env.NODE_ENV !== "production";

// options
pathify.options.strict = debug;
pathify.options.deep = 2;
